import { createContext } from 'rax';
const LocaleContext = createContext({
    locale: {},
});
export default LocaleContext;
